import { AddressConfirmationFormValues, AddressForm } from "@components/AddressForm";
import { Loader } from "@components/Loader";
import { useAddressDetails, useOnboarding, useSetUserFinancialProfile } from "@hooks";
import { useLocation } from "@entry/navigation";
import { EmployerConfirmationRouteProps } from "./types";

export const EmployerAddressConfirmationRoute = () => {
  const location = useLocation();

  const { resetToNext } = useOnboarding();
  const [setUserFinancialProfile] = useSetUserFinancialProfile();

  const placeId = (location.state as EmployerConfirmationRouteProps).placeId;

  const { data, loading } = useAddressDetails({ placeId });

  const handleSubmit = async (values: AddressConfirmationFormValues) => {
    await setUserFinancialProfile({
      variables: {
        employerAddressStreet: values.address,
        employerAddressUnitNo: values.address2,
        employerAddressCity: values.city,
        employerAddressState: values.state,
        employerAddressPostalCode: values.zipCode,
        employerAddressCountry: values.country,
      },
    });

    resetToNext();
  };

  if (loading) return <Loader />;

  return <AddressForm data={data} onSubmit={handleSubmit} />;
};
